import type { ResponseType } from 'axios'
import http from '@/utils/http'

// 添加 ApiResponse 接口定义
interface ApiResponse {
  code: number
  data: any
  msg: string
}

type HttpMethod = 'get' | 'post' | 'put' | 'delete' | 'patch'

const request = ({ headers, url, method, data, responseType }: {
  headers?: any,
  url: string,
  method: HttpMethod,
  data?: any,
  responseType?: ResponseType
}): Promise<ApiResponse> => {
  // GET请求需要将参数放在params中
  if (method.toLowerCase() === 'get') {
    return http[method](url, { 
      params: data,
      headers, 
      responseType 
    })
  }
  // 其他请求保持不变
  return http[method](url, data, { headers, responseType })
}

export default request